Ext.define('SA.data.quickreport.QuickReportDataRequest', {
    singleton: true,

    getQueryConfig(templateItem, locations) {
        var country = templateItem.getCountry(),
            locationSeries = locations.map(SA.data.LocationsCache.normalizeLocation),
            attributes = templateItem.getAttributes().concat('locationSeries');

        return SA.data.QueryConfig.create(country, locationSeries, attributes);
    },

    request(templateItem, locations) {
        var me = this,
            TemplateValueCache = SA.data.quickreport.QuickReportTemplateValueCache,
            cache = TemplateValueCache.get(templateItem.getId()),
            uncachedLocations = getUncachedLocations();

        if (uncachedLocations.length) {
            return fetchDataAndBuildResult();
        }
        else {
            return new Promise(resolve => {
                setTimeout(() => resolve(buildResult()), 0);
            });
        }

        function getUncachedLocations() {
            return locations.filter(location => !cache.hasEntry(location));
        }

        function fetchDataAndBuildResult() {
            var queryConfig = me.getQueryConfig(templateItem, uncachedLocations),
                query = SA.data.Query.from(queryConfig);

            query.run();

            return new Promise(resolve => {
                query.addSuccess(results => {
                    cache.addEntries(Ext.Array.toValueMap(results, 'locationSeries'));

                    buildResult().then(resolve);
                });
            });
        }

        function buildResult() {
            var Result = SA.data.quickreport.QuickReportDataResult,
                values = cache.getEntries(locations);

            return Result.build(templateItem, locations, values);
        }
    }
});